import { render, staticRenderFns } from "./EditAddMethodsBactAndFunc.vue?vue&type=template&id=2c313ef3&scoped=true"
import script from "./EditAddMethodsBactAndFunc.vue?vue&type=script&lang=js"
export * from "./EditAddMethodsBactAndFunc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c313ef3",
  null
  
)

export default component.exports